export const checkboxes = [
  "Portes garage principale + parking",
  "Vérification périodique de l'extracteur d'air des parkings",
  "Vérification périodique des extincteurs",
  "Blocs autonomes d’éclairage de sécurité (B.A.E.S) ou (B.A.E.H)",
  "Vérification périodique de l'extracteur d'air VH + VB",
  "Ascenseur",
  "Chauffage individuel",
  "Poste chaufferie gaz",
  "Poste géothermie (eau)",
  "VMC + conduite gaz",
  "Pompes de relevage parking",
  "Gaines techniques",
  "Détecteur de fumée",
  "Désenfumage",
  "Éclairage intérieur / extérieur",
  "Habilitations électrique pour CFO/CFA",
  "Travail en hauteur",
  "Occultations",
  "Travaux par point chaud",
  "Ravalement des façades + ITE",
  "Travaux de peinture",
  "Terrasse inaccessible",
  "Couverture / charpente / étanchéité",
  "Colonne sèche",
  "VRD + espace verts",
  "Eaux pluviales (tuyaux)",
  "Eaux usées (tuyaux)",
  "Eau froide",
  "Eau chaude",
  "Parking",
  "Portail automatique",
  "Poste de transformation HTA/BT",
  "Gardes-corps",
  "Étanchéité",
  "Eclairage Extérieure",
  "Bardage Métallique",
  "Système de sécurité Incendie",
  "Revêtement façade",
  "Panneaux photovoltaïques",
  "Bornes escamotables automatiques"
];

export const checkboxesContentsConst = [
  {
    description: "- PORTE MECANIQUE\nLe réseau et le matériel installés dans ce bâtiment sont repérés et décrits dans le dossier des ouvrages exécutés (DOE)",
    localization: "- Entrée et sortie du parking sous-terrain",
    natureOfInterventions: "- Remplacement\n- Entretien moteur\n- Maintenance",
    access: "- Depsis la voirie",
    risks: "- Chute de plain-pied\n- Heurt avec des personnes\n- Heurt avec des véhicules\n- Électrocution",
    securityMeasures: "- Port des EPI obligatoire\n- Seuls les personnes habilitées à intervenir sur les mécanismes de la porte sont autorisé à intervenir\n- Neutralisation des zones d’accès véhicules (entrant / sortant)\n- Balisage de la zone de travaux\n- Coupure électrique des mécanismes à proximité"
  },
  {
    description: "- Voir Plans",
    localization: "- Voir plans d’architecte",
    natureOfInterventions: "- Maintenance\n- Entretien périodique",
    access: "- Voir Plans",
    risks: "",
    securityMeasures: "- Port des EPI obligatoire\n- Seuls les personnes habilitées sont autorisées à intervenir sur les installations"
  },
  {
    description: "",
    localization: "",
    natureOfInterventions: "",
    access: "",
    risks: "",
    securityMeasures: ""
  },
  {
    description: "",
    localization: "- Circulation\n- Parkings\n- Escaliers\n- Paliers",
    natureOfInterventions: "- Nettoyage\n- Remplacement des lampes\n- Remplacement des batteries ",
    access: "- Par Plates-formes Individuelles Roulantes (P.I.R)",
    risks: "- Chute\n- Électrocution\n- Chute des luminaires\n- Risque de heurt avec des personnes",
    securityMeasures: "- Balisage de la zone d’intervention\n- Coupure du circuit électrique dans l’armoire divisionnaire\n- Personnel habilité\n- Tout le matériel électrique utilisé par les entreprises devra être conforme à la réglementation en vigueur sur les chantiers\n- Toute intervention sur les réseaux existant nécessite une procédure écrite et l’apposition d’étiquette de consignation\n- La validation sera effectuée par les services sécurité de l'immeuble"
  },
  {
    description: "- Voir Plans",
    localization: "- Voir plans d’architecte",
    natureOfInterventions: "- Maintenance\n- Entretien périodique",
    access: "- Voir Plans",
    risks: "",
    securityMeasures: "- Port des EPI obligatoire\n- Seuls les personnes habilitées sont autorisées à intervenir sur les installations"
  },
  {
    description: "- Ascenseur installé dans les parties communes",
    localization: "- Sur les paliers du RDC, R+1, R+2\n- Voir plans d’architecte",
    natureOfInterventions: "- Maintenance\n- Entretien périodique",
    access: "",
    risks: "- Chute de plain-pied\n- Chute de hauteur",
    securityMeasures: "- Port des EPI obligatoire\n- Seuls les personnes habilitées sont autorisées à intervenir sur les installations"
  },
  {
    description: "- Réseaux de chauffage (INDIVIDUEL)",
    localization: "",
    natureOfInterventions: "- Accès aux réseaux (contrôles périodiques)\n- Fuites",
    access: "",
    risks: "- Chute de plain-pied",
    securityMeasures: ""
  },
  {
    description: "- Maintenance préventive",
    localization: "- Niveau rez-de-chaussée bas SS1/SS2\n- Niveau ss1/ss2 (sous-sol)",
    natureOfInterventions: "- Forte odeur de gaz\n- Fonctionnement anormal\n- Contrôle de fonctionnement annuel",
    access: "- Suivant plans du MOE ou par la porte d'accès au local",
    risks: "- Risque de fuite de gaz\n- Risque électrique\n- Éclairage du local",
    securityMeasures: "- Mise hors tension de l'équipement et/ou coupure de l'arrivée du gaz\n- Personne habilitée par consignation\n- Appareil de mesure de gaz"
  },
  {
    description: "- Maintenant préventive",
    localization: "- Niveau rez-de-chaussée bas/SS1/SS2\n- Niveau ss1/ss2 (sous-sol)",
    natureOfInterventions: "- Contrôle de la pression\n- Fonctionnement anormal\n- Contrôle périodique\n- Éclairage du locale ou des locaux",
    access: "- Suivant plans du MOE ou par la porte d'accès au local",
    risks: "- Risque de brulure\n- Risque de chauffe anormal\n- Risque fuite anormale",
    securityMeasures: "- Habilitation requise pour ce type de poste\n- Être en binôme\n- Avoir l’accréditation"
  },
  {
    description: "",
    localization: "",
    natureOfInterventions: "- Accès aux réseaux notamment Ventilation Mécanique Contrôlés (contrôles périodiques)",
    access: "- Echafaudages\n- Skydome + Échelle",
    risks: "- Approvisionnement\n- Chute d’objet",
    securityMeasures: "- Port des EPI obligatoire\n- Seul les personnes habilitées à intervenir sur installations de ventilation électrique sont autorisé à intervenir"
  },
  {
    description: "- Pompe située dans le parking sous-sol",
    localization: "Parking",
    natureOfInterventions: "- Accès aux réseaux (contrôles périodiques)\n- Fuites",
    access: "- Les accès aux locaux techniques sont prévus pour entrer et sortir par des moyens adaptés (porte sécurisé)",
    risks: "- Chute de plain-pied",
    securityMeasures: "- Port des EPI obligatoire\n- Seuls les personnes habilitées sont autorisées à intervenir sur les installations"
  },
  {
    description: "- Gaines palières : courant fort, courant faible, informatique, EDF, services généraux électriques",
    localization: "- Sur les paliers",
    natureOfInterventions: "- Entretien\n- Maintenance\n- Dépannage",
    access: "- De plain-pied",
    risks: "- Électrocution",
    securityMeasures: "- Personnes habilitées à intervenir sur les installations électriques\n- Toute intervention sur les réseaux existant nécessite une procédure écrite et l’apposition d’étiquette de consignation. La validation sera effectuée par le service technique"
  },
  {
    description: "- Voir Plans",
    localization: "- Voir plans d’architecte",
    natureOfInterventions: "- Maintenance\n- Entretien périodique",
    access: "- Voir Plans",
    risks: "",
    securityMeasures: "- Port des EPI obligatoire\n- Seuls les personnes habilitées sont autorisées à intervenir sur les installations"
  },
  {
    description: "- Désenfumage mécanique et à gaz installé dans les parties communes",
    localization: "- Sur les paliers du RDC et R+2\n- Voir plans d’architecte",
    natureOfInterventions: "- Maintenance\n- Entretien périodique",
    access: "",
    risks: "",
    securityMeasures: "- Port des EPI obligatoire\n- Seuls les personnes habilitées sont autorisées à intervenir sur les installations"
  },
  {
    description: "(Voir plans architecte et DOE)",
    localization: "- Dans les parties communes\n(Voir plans architecte et DOE)",
    natureOfInterventions: "- Changements ou maintenance des systèmes d’éclairage\n- Dépoussiérage des lampes et des luminaires extérieurs et intérieurs",
    access: "- Par plate-forme individuelle roulante (P.I.R), l’usage d’échelles et d’escabeaux étant prohibé",
    risks: "- Chute\n- Chute des luminaires\n- Choc électrique\nRisque de heurt avec des personnes",
    securityMeasures: "- Balisage de la zone d’intervention\n- Coupure de circuit électrique dans l’armoire divisionnaire\n- Seul le personnel habilité est autorisé à intervenir\n- Tout le matériel électrique utilisé par les entreprises devra être conforme à la réglementation en vigueur\n- Toute intervention sur les réseaux existant nécessite une procédure écrite et l’apposition d’étiquette de consignation. La validation sera effectuée par le service de sécurité"
  },
  {
    description: "",
    localization: "",
    natureOfInterventions: "",
    access: "",
    risks: "",
    securityMeasures: ""
  },
  {
    description: "",
    localization: "",
    natureOfInterventions: "",
    access: "",
    risks: "",
    securityMeasures: ""
  },
  {
    description: "- Menuiserie extérieure",
    localization: "- Sur l’ensemble du bâtiment",
    natureOfInterventions: "- Nettoyage\n- Remplacements des vitrages",
    access: "- Accès par nacelle, échafaudages\n- Accès depuis les balcons\n- Accès par la rue pour occultations du RDC",
    risks: "- Coupure\n- Chute de plain-pied\n- Chute d’objet des étages",
    securityMeasures: "- Utiliser des gants de manutention pour manipuler les verres\n- Utilisation d’échafaudage roulant\n- Balisage de la zone d’intervention"
  },
  {
    description: "",
    localization: "",
    natureOfInterventions: "",
    access: "",
    risks: "",
    securityMeasures: ""
  },
  {
    description: "- Ravalement des façades\n(Voir plan d’architecte pour plus de précision sur les façades)",
    localization: "- Façades Mitoyenne\n- Façade côté rue\n- Façade côté jardin",
    natureOfInterventions: "- Ravalement",
    access: "- Échafaudage encorbellement sur mur mitoyen\n- Échafaudage de pieds ou nacelle télescopique",
    risks: "- Chute de hauteur\n- Chute d’objet",
    securityMeasures: "- Échafaudage à montage en sécurité\n- Filet de protection toute hauteur\n- Tunnel de protection au droit des accès aux bâtiment\n- Balisage de la zone d’évolution de la nacelle\n- Calepinage parfais demandé par l’Inspection du travail"
  },
  {
    description: "- Travaux de peinture sur supports divers (murs, boiseries, canalisations…)\n- Tous les produits à utiliser devront être adaptés aux conditions rencontrées et en fonction de l'exposition des surfaces extérieures et intérieures, de l'exposition en atmosphère agressive, etc.",
    localization: "- Intérieur\n- Extérieur",
    natureOfInterventions: "- Entretien",
    access: "- Par Plate-forme Individuelle Roulante (P.I.R.) l’usage d’échelles et d'escabeaux étant prohibé\n- Échafaudage de pied",
    risks: "- Chutes\n- Utilisation de produits avec du solvant\n- Chute d’objet\n- Heurt avec les personnes",
    securityMeasures: "- Balisage de la zone d’intervention\n- Les modalités d’intervention devront permettre le respect des normes d’évacuation d’urgence\n- Ventilation des locaux\n- Isolation de la zone concernée\n- Préférer les peintures professionnelles en solution aqueuse\n- Demander préalablement au fournisseur la Fiche de Données de Sécurité (F.D.S.) pour s’informer précisément des risques pour la santé"
  },
  {
    description: "- Toiture terrasse végétalisé",
    localization: "- Terrasse inaccessible avec acrotère normalisé de 1,10m et de garde-corps",
    natureOfInterventions: "- Remplacement de matériel\n- Approvisionnement de matériel\n- Si besoin d’une installation électrique :\n• Prévoir Pose prise de courant 10/16 A + T\n• Protégée par un disjoncteur différentiel\n• Haute sensibilité 30 mA",
    access: "- Echafaudage extérieur à tour\n- Skydome + Échelle",
    risks: "- Approvisionnement\n- Chute d’objet",
    securityMeasures: "- Port des EPI obligatoire\n- Seul les personnes habilitées à intervenir sur installations de ventilation électrique sont autorisé à intervenir\n- Port de harnais de sécurité"
  },
  {
    description: "- Étanchéité multicouche, sur support béton, composée de :",
    localization: "- Toiture inaccessible",
    natureOfInterventions: "",
    access: "- Skydome + échelles\n- Echafaudage à tour",
    risks: "- Approvisionnement\n- Chute d’objet\n- Chute de hauteur\n- Chute de plain-pied",
    securityMeasures: "- Port des EPI obligatoire\n- Seuls les personnes habilitées à travailler sur la couverture / charpente / étanchéité peuvent intervenir\n- Port de harnais de sécurité"
  },
  {
    description: "- Colonne sèche mis à disposition des pompiers",
    localization: "- Non indiqué sur les plans d’architecte",
    natureOfInterventions: "- Entretien",
    access: "- De plain-pied ",
    risks: "- Chute de plain-pied",
    securityMeasures: "- Port des EPI obligatoire\n- Seuls les personnes habilitées sont autorisées à intervenir sur les installations"
  },
  {
    description: "- Voir Plans",
    localization: "- Voir plans d’architecte",
    natureOfInterventions: "- Maintenance\n- Entretien périodique",
    access: "",
    risks: "",
    securityMeasures: "- Port des EPI obligatoire\n- Seuls les personnes habilitées sont autorisées à intervenir dans les parties communes"
  },
  {
    description: "- Voir plans d'architecte",
    localization: "- Passage au sous-sol (1)\n- Passage au sous-sol (2)",
    natureOfInterventions: "- Problème de fuite, de feu ou accidentel\n- Incendie fortuite\n- Dégradation volontaire",
    access: "- Suivant les plans de l'architecte",
    risks: "- Intoxication suite chaleur ou incendie",
    securityMeasures: "- Habilitation requise"
  },
  {
    description: "- Voir plans architecte",
    localization: "- Passage au sous-sol (1)\n- Passage au sous-sol (2)",
    natureOfInterventions: "- Problème de fuite, de feu ou accidentel\n- Incendie fortuite\n- Dégradation volontaire",
    access: "- Suivant les plans de l'architecte",
    risks: "- Intoxication en cas de fuite\n- Canalisation dégradée avec le temps",
    securityMeasures: "- Habilitation requise"
  },
  {
    description: "- Réseau de distribution d'eau froide sanitaire (EFS)\n- Dossier des ouvrages exécutés (DOE)",
    localization: "- Gaine technique\n- Sous-sol / Locaux techniques\n- Paliers\n- Sous-sol",
    natureOfInterventions: "- Maintenance préventive et curative\n- Recherche et réparation de fuites\n- Remplacement de vannes et compteurs",
    access: "- De plain-pied\n- Via gaines palières\n- Sous-sol",
    risks: "- Chute de plain-pied\n- Dégât des eaux / Inondation\n- Glissade",
    securityMeasures: "- Coupure et consignation de l'arrivée d'eau générale du secteur\n- Port des EPI obligatoire (gants, chaussures de sécurité)\n- Balisage de la zone en cas d'écoulement\n- Prévenir le conseil syndical"
  },
  {
    description: "- Réseau de distribution d'eau chaude sanitaire (ECS)\n- Équipements de production et bouclage",
    localization: "- Chaufferie / Sous-sol\n- Gaines techniques palières",
    natureOfInterventions: "- Entretien du réseau de bouclage\n- Traitement anti-légionelle\n- Réparation de fuites et remplacement d'organes",
    access: "- De plain-pied\n- Accès aux locaux techniques par porte sécurisée",
    risks: "- Risque de brûlure thermique\n- Dégât des eaux\n- Risque bactériologique (légionelles)",
    securityMeasures: "- Port des EPI obligatoire (gants anti-chaleur, lunettes)\n- Isolation thermique et consignation des fluides avant intervention\n- Contrôle des températures de consigne"
  },
  {
    description: "- Zones de stationnement sous-sol et/ou aérien\n- Plans d'architecte",
    localization: "- Niveaux sous-sol (SS1/SS2) et/ou extérieur",
    natureOfInterventions: "- Nettoyage des sols\n- Reprise des marquages au sol\n- Entretien de la signalétique",
    access: "- Via voirie et rampes d'accès",
    risks: "- Risque de heurt avec des véhicules en circulation\n- Chute de plain-pied\n- Intoxication aux gaz d'échappement",
    securityMeasures: "- Port du gilet haute visibilité et EPI obligatoire\n- Balisage / Neutralisation des voies de circulation pendant l'intervention\n- Se munir d'un éclairage portatif adapté"
  },
  {
    description: "- Motorisation et automatisme de portail d'accès",
    localization: "- Limite de propriété / Entrée de résidence",
    natureOfInterventions: "- Maintenance préventive et réglage des cellules\n- Dépannage moteur et armoire de commande\n- Remplacement de pièces d'usure",
    access: "- De plain-pied depuis la voirie",
    risks: "- Risque d'écrasement ou de coincement mécanique\n- Choc électrique\n- Heurt avec un véhicule",
    securityMeasures: "- Coupure et consignation de l'alimentation électrique\n- Neutralisation de la zone d'accès (balisage / cônes)\n- Intervention par du personnel habilité en électricité et mécanique"
  },
  {
    description: "- Poste de transformation Haute Tension / Basse Tension (HTA/BT)\n- Plans d'architecte",
    localization: "- Local technique dédié en rez-de-chaussée ou sous-sol\n- Local technique ou éxterieur",
    natureOfInterventions: "- Contrôle périodique et entretien des cellules HTA\n- Manœuvres d'exploitation\n- Remplacement de transformateur",
    access: "- Accès réservé aux personnes habilitées par porte sécurisée spécifique",
    risks: "- Électrocution / Arc électrique HTA\n- Risque d'incendie\n- Confinement dans le local",
    securityMeasures: "- Strictement réservé au personnel possédant l'habilitation électrique HTA (H1/H2/HC)\n- Procédure rigoureuse de consignation / déconsignation avec fiche d'intervention\n- Port du kit d'EPI spécifique (casque à visière anti-arc, gants isolants)"
  },
  {
    description: "- Ensemble des garde-corps de balcons, terrasses et fenêtres\n- Plans d'architecte",
    localization: "- Façades, balcons, fenêtres et terrasses du bâtiment",
    natureOfInterventions: "- Vérification des ancrages et fixations\n- Reprise de peinture / traitement anticorrosion\n- Remplacement d'éléments endommagés",
    access: "- Depuis l'intérieur des logements / parties communes\n- Depuis l'extérieur par nacelle ou échafaudage",
    risks: "- Chute de hauteur\n- Chute d'objets ou d'outils vers le bas",
    securityMeasures: "- Port du harnais de sécurité relié à une ligne de vie ou point d'ancrage conforme en cas d'intervention en rive de vide\n- Balisage de la zone de sécurité au sol sous l'intervention\n- Seuls les professionnels qualifiés sont autorisés à intervenir"
  },
  {
    description: "- Complexe d'étanchéité des toitures, terrasses et relevés\n- Plans d'architecte",
    localization: "- Toitures terrasses et casquettes béton",
    natureOfInterventions: "- Réfection ou réparation des membranes d'étanchéité\n- Nettoyage des gouttières et naissances\n- Inspection périodique",
    access: "- Skydome + échelle fixe d'accès à la toiture\n- Échafaudage de pied ou à tour\n- Monte matériaux + nacelle selon hauteur",
    risks: "- Chute de hauteur\n- Brûlure en cas d'application à chaud (chalumeau)\n- Chute d'objet",
    securityMeasures: "- Port du harnais de sécurité et EPI obligatoires\n- Délivrance obligatoire d'un Permis de Feu pour les travaux au chalumeau avec extincteur à proximité\n- Protection des zones d'accès sous les points de levage"
  },
  {
    description: "- Réseau et luminaires d'éclairage des espaces extérieurs et façades\n- Plans d'architecte",
    localization: "- Voies de circulation, chemins piétons, façades et espaces verts",
    natureOfInterventions: "- Remplacement des ampoules / dalles LED\n- Entretien des mâts et bornes lumineuses\n- Recherche de défaut d'isolement sur le réseau enterré",
    access: "- De plain-pied ou via Plate-forme Individuelle Roulante (P.I.R) / Nacelle selon la hauteur",
    risks: "- Choc électrique\n- Chute d'hauteur (si mât)\n- Heurt avec les usagers ou véhicules",
    securityMeasures: "- Coupure de l'alimentation électrique au tableau divisionnaire (consignation)\n- Balisage de la zone d'intervention autour du mât ou de la borne\n- Intervention réservée au personnel ayant une habilitation électrique à jour"
  },
  {
    description: "- Complexe de bardage métallique en façade (plaques, cassettes ou bac acier)\n- Isolation thermique associée\n- Plans d'architecte",
    localization: "- Façades extérieures du bâtiment",
    natureOfInterventions: "- Remplacement de lames ou cassettes endommagées\n- Nettoyage et entretien des parements\n- Inspection des fixations et ossatures",
    access: "- Accès par nacelle élévatrice, échafaudage de pied ou encorbellement",
    risks: "- Chute de hauteur\n- Chute d'éléments de bardage ou d'outils\n- Risque de coupure lié aux tôles métalliques",
    securityMeasures: "- Port des EPI obligatoire (gants anti-coupure, casque, chaussures)\n- Port du harnais de sécurité relié à un point d'ancrage conforme\n- Balisage de la zone au sol sous les travaux\n- Montage des échafaudages par des professionnels qualifiés"
  },
  {
    description: "- Centrales SSI, équipements d'alarme (EA), déclencheurs manuels et réarmement\n- Centrale de détection et éléments asservis\n- Plans d'architecte",
    localization: "- Hall d'entrée, circulations parties communes et locaux techniques",
    natureOfInterventions: "- Essais périodiques et maintenance réglementaire\n- Remplacement des batteries d'alimentation de secours\n- Dépannage et remplacement des voyants/détecteurs",
    access: "- De plain-pied ou échafaudage roulant / PIR pour les éléments en hauteur",
    risks: "- Choc électrique\n- Risque de fausse alerte / perturbation des usagers\n- Chute lors du travail en hauteur",
    securityMeasures: "- Intervention effectuée par un technicien SSI qualifié\n- Information préalable des occupants avant les tests d'alarme sonore\n- Coupure des alimentations électriques secondaires avant manipulation si nécessaire\n- Utilisation d'une PIR (Plate-forme Individuelle Roulante)"
  },
  {
    description: "- Parements et revêtements extérieurs de façade (enduits, briquettes, carrelage collé, résine)\n- Plans d'architecte",
    localization: "- Façades extérieures, soubassements et retours de baies",
    natureOfInterventions: "- Réparation des désordres (fissures, décollements)\n- Lavage / Démoussage des surfaces\n- Application d'un traitement hydrofuge ou de finition",
    access: "- Nacelle articulée, échafaudage roulant ou de pied",
    risks: "- Chute de hauteur\n- Projection de produits ou poussières (yeux/voies respiratoires)\n- Chute de matériaux",
    securityMeasures: "- Port des EPI obligatoire (lunettes de protection, masque FFP2, gants)\n- Installation d'un filet de protection sur l'échafaudage\n- Balisage rigoureux du périmètre au sol au droit des interventions"
  },
  {
    description: "- Centrale photovoltaïque auto-consommation ou revente\n- Onduleurs, câblage DC/AC (courant continu et alternatif) et modules photovoltaïques\n - Plans d'architecte (DOE)",
    localization: "- Toiture terrasse / Toiture inaccessible\n- Plans d'architecte (DOE)",
    natureOfInterventions: "- Nettoyage des modules photovoltaïques\n- Inspection préventive des connexions et des onduleurs\n- Remplacement de modules ou composants défectueux",
    access: "- Skydome + échelle fixe d'accès à la toiture\n- Échafaudage à tour\n- Toiture inaccessible",
    risks: "- Chute de hauteur\n- Risque d'électrocution (courant continu sous tension constante la journée)\n- Brûlure thermique\n- Glissade sur modules ou toiture",
    securityMeasures: "- Intervention réservée au personnel habilité électricité (BP / BR photovoltaïque)\n- Habilitation conventionnelle (voir DIUO)\n- Port des EPI obligatoire (harnais de sécurité, gants isolants, chaussures antidérapantes)\n- Consignation préalable côté DC (courant continu) et AC (courant alternatif) avant intervention sur les circuits\n- Ne jamais intervenir par temps pluvieux ou orageux"
  },
  {
    description: "- Bornes escamotables automatiques (ou bornes rétractables), utilisées pour contrôler l'accès des véhicules à une place ou à une zone piétonne.",
    localization: "- Voir plans d’architecte",
    natureOfInterventions: "- Maintenance\n- Entretien périodique",
    access: "- De plain-pied\n- Voir plan d'aménagement",
    risks: "- Chute de plain-pied\n- Chute d'objet\n- Coupure",
    securityMeasures: "- Port des EPI obligatoire\n- Seuls les personnes habilitées sont autorisées à intervenir dans les parties communes\n- Baliser la zone d'intervention"
  }
]